import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('root')

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(<App />)

// 開発時のみ Web Vitals をコンソール出力。本番計測時はコールバックを GTM 等へ差し替える
// eslint-disable-next-line no-console
reportWebVitals(process.env.NODE_ENV === 'development' ? console.log : undefined)
